import {useEffect} from "react"
import {useIsUnitSuperUser, useUserClaimsData} from "../services/auth"

const useZendesk = (shouldInitialize = false) => {
	const userTokenData = useUserClaimsData()
	const isSuperUser = useIsUnitSuperUser()

	useEffect(() => {
		try {
			if (!shouldInitialize) {
				return
			}

			if (window.zE) {
				window.zE("webWidget", "reset")

				// Enable zendesk widget
				window.zE("webWidget", "updateSettings", {
					webWidget: {
						contactForm: {
							suppress: false,
							selectTicketForm: {
								"*": "What can we help you with?",
							},
						},
						zIndex: 30,
					},
				})

				// Identify user
				window.zE("webWidget", "identify", {
					name: "",
					email: userTokenData.sub,
					organization: userTokenData.org,
				})

				// Prefill contact form
				if (!isSuperUser && userTokenData.sub) {
					window.zE("webWidget", "prefill", {
						email: {
							value: userTokenData.sub,
							readOnly: true, // optional
						},
					})
				}
			}
		} catch (e) {
			console.log("Error initializing zendesk widget", e)
		}
	}, [shouldInitialize])
}

export default useZendesk
